(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.controller
  (:require
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller
    :refer [company-financials]]
   [frontend.ui.component.lp-portal.report.company.net-debt-chart.controller :as net-debt-controller]
   [frontend.ui.component.lp-portal.report.company.net-debt-chart.controller
    :refer [company-net-debt]]
   [frontend.ui.component.lp-portal.report.company.overview.controller :as company-overview]
   [frontend.ui.component.lp-portal.report.company.value-chart.controller :as valuation-controller]
   [frontend.ui.component.lp-portal.report.company.value-chart.controller
    :refer [company-valuation]]
   [frontend.ui.component.lp-portal.report.company.enterprise-value-chart.controller :as
    enterprise-value-ctl]
   [frontend.ui.component.lp-portal.report.company.money-multiple-distribution-chart.controller :as
    money-multiple-distribution-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- overview
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  (merge
   {:case-overview (report-ctl/rich-content
                    props
                    :case-overview-text)
    :latest-development (report-ctl/rich-content
                         props
                         :latest-development-text)
    :overview-figures (report-ctl/with-footnote
                       props
                       :overview-figures-footnotes
                       (company-overview/overview-figures (get-in report-data [:basic-equity])))
    :board (report-ctl/with-footnote
            props
            :board-footnotes
            (company-overview/overview-figures-board (get-in report-data [:basic-equity])))}))

(defn valuation
  [{:keys [dynamic-path dynamic-data report-data]}]
  (company-valuation (get-in report-data [:valuation])))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name          (get-in report-data [:holding-name])
   :reference-date        (get-in report-data [:reference-date])
   :report-id             (:report-id props)
   :overview              (overview (update props :dynamic-path concat [:overview]))
   :financial-performance (report-ctl/rich-content props :financial-performance-text)
   :financials            (->>
                            (get-in report-data [:financials])
                            (report-ctl/with-footnote props :financials-footnotes)
                            (report-ctl/with-editable-charts
                             props
                             :financials
                             financials-controller/company-financials
                             financials-controller/config->editable-data
                             financials-controller/editable-data->raw-data))
   :net-debt              (->>
                            (get-in report-data [:net-debt])
                            (report-ctl/with-footnote props :net-debt-footnotes)
                            (report-ctl/with-editable-charts
                             props
                             :net-debt
                             net-debt-controller/company-net-debt
                             net-debt-controller/config->editable-data
                             net-debt-controller/editable-data->raw-data))
   :enterprise-value      (->>
                            (get-in report-data [:enterprise-value])
                            (report-ctl/with-footnote props :enterprise-value-footnotes)
                            (report-ctl/with-editable-charts
                             props
                             :enterprise-value
                             enterprise-value-ctl/chart-config
                             enterprise-value-ctl/config->editable-data
                             enterprise-value-ctl/editable-data->raw-data))

   :money-multiple-distribution (->>
                                  (get-in report-data [:money-multiple-distribution])
                                  (report-ctl/with-footnote props :money-multiple-distribution-footnotes)
                                  (report-ctl/with-editable-charts
                                   props
                                   :money-multiple-distribution
                                   money-multiple-distribution-ctl/chart-config
                                   money-multiple-distribution-ctl/config->editable-data
                                   money-multiple-distribution-ctl/editable-data->raw-data))

   :value-creation-plan   (report-ctl/rich-content props :value-creation-plan-text)
   :valuation-text        (report-ctl/rich-content props :valuation-text)
   :valuation             (->>
                            (get-in report-data [:valuation])
                            (report-ctl/with-footnote props :valuation-footnotes)
                            (report-ctl/with-editable-charts
                             props
                             :valuation
                             valuation-controller/company-valuation
                             valuation-controller/config->editable-data
                             valuation-controller/editable-data->raw-data))
   :ownership             (report-ctl/with-footnote
                           props
                           :ownership-footnotes
                           (get-in report-data [:ownership]))
   :optional-section      (report-ctl/optional-rich-content
                           props
                           :optional-section-heading
                           :optional-section-text)})
